module.exports = __webpack_public_path__ + "img/kou_winter.011fd9cd.png";